<template>
  <a class="dropdown-item cursor-pointer" @click="handle">Edit message</a>
</template>

<script>
import eventBus from "../../../event-bus";

export default {
  props: {
    message: Object,
    url: String,
  },

  methods: {
    /**
     * @emits on-message-edit
     */
    handle() {
      eventBus.$emit('on-message-edit', {message: this.message, url: this.url});
    },
  },
}
</script>

<style scoped>

</style>
